import { memo } from 'react';
import { Stack } from '@mui/material';

import type { RackingArea, SingularStationArea } from '@thive/fddm-types';

import { DefaultHeader } from './DefaultHeader';
import { SelectionHeader } from './SelectionHeader';
import { AreaDetails } from './AreaDetails';
import { SelectionHeaderState } from './helpers';
// import { type SelectedEntityItem } from './SelectedEntitiesList';

// type Props = {
//   selectedItems: SelectedEntityItem[];
// };

// hide selected items for now, i think it might come back

type Props = {
  /** Null when nothing is selected */
  selectionHeader: SelectionHeaderState | null;
  selectedSingularStationAreas: SingularStationArea[];
  selectedRackingAreas: RackingArea[];
};

function HeaderComponent({
  selectionHeader,
  selectedSingularStationAreas, 
  selectedRackingAreas,
}: Props) {
//   {
//   selectedItems
// }: Props
  return (
    <Stack gap={0}>
      {selectionHeader === null ? (
        <DefaultHeader />
      ) : (
        <>
          <SelectionHeader
            label={selectionHeader.label}
            editable={selectionHeader.editable}
            canDuplicateMulti={selectionHeader.canDuplicateMulti}
          />
          {/* <SelectedEntitiesList selectedItems={selectedItems} /> */}
          {(selectedSingularStationAreas.length > 0 || selectedRackingAreas.length > 0) && (
            <AreaDetails
              selectedSingularStationAreas={selectedSingularStationAreas}
              selectedRackingAreas={selectedRackingAreas}
            />
          )}
        </>
      )}
    </Stack>
  );
}

export const Header = memo(HeaderComponent);
